import { Component, OnInit, Input, OnDestroy, Inject, DestroyRef } from '@angular/core';
import { RolesService } from '@app/roles/roles.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-checkboxs',
  templateUrl: './checkboxs.component.html',
  styleUrls: ['./checkboxs.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS, SkeletonComponent]
})
export class CheckboxsComponent implements OnInit {
  @Input() listPrefix: string;
  @Input() firstForm: FormGroup;
  @Input() isEdit: any;
  @Input() field: any;
  keys = <any>[];
  cid = '';
  form: FormGroup;
  formObj = {};
  checkBoxLoaded: boolean;
  modules = {};
  select_all: boolean;
  moduleName: string;
  permissionKey: string;
  constructor(
    private root: RolesService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.cid = this.root.cid;
    // console.log('ffff', this.field);
    // console.log('data dialog ', this.dialogData);
    if (this.isEdit) {
      this.checkBoxLoaded = true;
      this.root.update_form.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        if (!this.form) {
          this.modules = res['data'];
          // console.log('res', res);

          this.dynamicForm(this.modules);
        }
        this.patchFormValue(res['data']);
      });
    } else {
      this.root.listData.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        // console.log('res list data', res);
        if (res['listPrefix'] === this.listPrefix) {
          this.modules = res['data'];
          if (!this.form) {
            this.dynamicForm(this.modules);
          }
          this.checkBoxLoaded = true;
        }
      });
    }
  }
  dynamicForm(modules: {}) {
    // console.log(this.isEdit);
    // console.log('modules', modules);

    this.keys = Object.keys(modules);
    // console.log('this.keys', this.keys);

    for (const key in modules) {
      this.formObj[key] = this.createItem(modules[key]);
    }
    this.initForm(this.formObj);
    this.root.checkboxesValues = this.form.value;
    this.form.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((value: any) => {
        // console.log("value", value);
        this.checkReadPermissions(value[this.moduleName]);

        // let permissions = ['create', 'update', 'remove'];

        this.root.checkboxesValues = value;
        var arr = [];
        for (const key in value) {
          arr.push(...Object.values(value[key]));
        }
        arr = arr.filter(v => typeof v === 'boolean');
        this.select_all = arr.every(e => e);
        if (this.isEdit) this.firstForm.markAsDirty();
      });
  }
  checkReadPermissions(modulePermissions: any) {
    // console.log("modulePermissions", modulePermissions);
    let key = this.moduleName ? this.moduleName.replace('_', '-') : '';
    let permissions = ['create', 'update', 'delete'];
    let arr = [];
    for (const k in modulePermissions) {
      if (permissions.includes(k.split('-')[0])) {
        arr.push(modulePermissions[k.split('-')[0] + '-' + key]);
      }
    }
    if (arr.some(d => d)) {
      this.checkItemByName(
        this.moduleName,
        'read-' + key,
        arr.some(d => d)
      );
      // this.disableByModuleNameAndKey(this.moduleName, 'read-' + key)
    } else {
      this.checkItemByName(this.moduleName, 'read-' + key);
    }
  }

  initForm(keys: {}) {
    this.form = this.fb.group(keys);
  }

  createItem(arr: any[]): FormGroup {
    var obj = {};
    // console.log("arr create item", arr);

    arr.forEach((el: string) => {
      obj[el['name']] = [el['is_selected']];
    });

    return this.fb.group(obj);
  }
  unCheckUnSelectAll(event: any, selectAll: any, moduleName: string) {
    this.moduleName = moduleName;
    if (!event.checked) {
      selectAll.checked = false;
    }
  }
  checkItemByName(moduleName: string, key: string, value: boolean = false) {
    // console.log("module", this.modules[moduleName]);
    let index = this.modules[moduleName].indexOf(this.modules[moduleName].find((d: any) => d.name === key));
    this.modules[moduleName][index]['is_selected'] = value;
    this.modules[moduleName][index]['is_disabled'] = value;
    // this.form.get(moduleName)['controls'][key].patchValue(true)
  }

  onSelectAll(e: any, key: string) {
    e['checked'] ? this.keySelectAll(key) : this.keyUnSelectAll(key);
  }
  selectAll(event: any) {
    for (const k in this.form.value) {
      this.moduleName = k;
      for (const key in this.form.value[k]) {
        // console.log("key", key);
        this.moduleName = k;
        this.form.controls[k].patchValue({
          [key]: event.checked
        });
      }
      this.checkReadPermissions(this.form.value[k]);
    }
  }

  keySelectAll(key: string) {
    var obj = {};
    for (let k in this.form.value[key]) {
      this.form.controls[key].patchValue({
        [k]: true
      });
    }
  }
  keyUnSelectAll(key: string) {
    this.form.controls[key].reset();
  }

  patchFormValue(modules: {}) {
    let formValue = JSON.parse(JSON.stringify(this.form.value));
    for (const key in modules) {
      this.moduleName = key;
      modules[key].forEach((element: any) => {
        formValue[key][element['name']] = element['is_selected'];
      });
      this.checkReadPermissions(formValue[this.moduleName]);
    }

    // console.log("formValue",formValue);

    this.form.patchValue(formValue);
  }
}
